<template>  
  <div v-if="!!lessonsOffline.length" class="container-fluid container-slider px-2 px-md-2 px-lg-5">
    <div class="row">
      <div class="col-12 py-3">
        <h3 class="h4 title text-white">Últimos videos</h3>
      </div>
    </div>
    <vueper-slides
      class="no-shadow"
      :visible-slides="4"
      slide-multiple
      :gap="3"
      :bullets="false"
      :slide-ratio="1 / 5"
      :dragging-distance="75"
      :parallax="false"
      :parallax-fixed-content="false"
      :breakpoints="{ 
        600: { autoplay: true, arrows: false, visibleSlides: 1, slideMultiple: 1, slideRatio: 1 / 1 },
        768: { autoplay: true, arrows: false, visibleSlides: 2, slideMultiple: 2, slideRatio: 1 / 3 }, 
        992: { autoplay: true, arrows: false, visibleSlides: 2, slideMultiple: 2, slideRatio: 1 / 3 }, 
        1200: { visibleSlides: 3, slideMultiple: 3, slideRatio: 1 / 4 } }"
    >
      <vueper-slide v-for="(lesson, key) in lessonsOffline" :key="key">
        <template v-slot:content>
          <div class="vueperslide__content-wrapper">
            <a :href="'/'+lesson.user.slug+'/'+lesson.slug">
              <div class="card card-video shadow rounded-1 border-0">
                <img :src="(lesson.imageUrl)" class="card-img" alt="test">
                <div class="card-img-overlay text-center">
                  <div class="row h-100">
                    <div class="col-12 mt-auto">
                      <h6 class="text-white text-truncate">{{ lesson.name }}</h6>
                      <p>
                        <a :href="'/'+lesson.user.slug+'/'+lesson.slug" class="btn btn-info btn-sm text-white">
                          <span class="icon-play-circle-regular"></span>
                          Ver Vídeo
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </template>
      </vueper-slide>
    </vueper-slides>
  </div>
</template>

<script>
import {VueperSlides, VueperSlide} from 'vueperslides';
import 'vueperslides/dist/vueperslides.css';

export default {
  name: "OfflineLessonCarousel",
  components: {
    VueperSlides,
    VueperSlide
  },
  props: ['user_id', 'lesson_id'],
  data(){
    return {
      lessonsOffline: [],
    }
  },
  mounted() {
    this.fetchRandomLessons();
  },
  methods: {
    fetchRandomLessons() {
      axios.get('/api/random-lessons-offline', {
        params: {
          'user_id': this.user_id,
          'lesson_id': this.lesson_id,
        }
      }).then(result => {
        this.lessonsOffline = result.data;
      }).catch(error => {
        console.log(error);
      })
    }
  },
}
</script>